import get from 'lodash/get';
import {
  ACTIONS,
  DIALOG_TITLE,
  MESSAGES_STATUS_FILTER_OPTIONS,
} from '../../constants/strings';
import { COMMUNITY_BTN_ACTIONS } from '../../constants';
import { IDS } from '../../constants/ids';

export default (community, formatMessage, isCommunityPage) => {
  const isCommunityMember = get(community, 'currentUserRole');
  const joinRequest = get(community, 'joinRequest');
  const memberInvitationId = get(community, 'memberInvitationId');

  if (memberInvitationId) {
    return {
      type: COMMUNITY_BTN_ACTIONS.ACCEPT,
      id: IDS.COMMUNITY.ACCEPT_INVITATION_BTN,
      buttonText: formatMessage({ id: 'common.accept' }),
      disabled: false,
    };
  }

  if (isCommunityMember) {
    return {
      buttonText: formatMessage(
        isCommunityPage
          ? ACTIONS.community.createPost
          : MESSAGES_STATUS_FILTER_OPTIONS.joined,
      ),
      id: isCommunityPage ? IDS.COMMUNITY.CREATE_POST_BTN : null,
      disabled: !isCommunityPage,
    };
  }

  return joinRequest
    ? {
        buttonText: formatMessage(DIALOG_TITLE.accessRequested),
        id: null,
        disabled: true,
      }
    : {
        buttonText: formatMessage(DIALOG_TITLE.join),
        id: IDS.COMMUNITY.JOIN_BTN,
        disabled: false,
      };
};



// WEBPACK FOOTER //
// ./src/utils/communities/getButtonInfo.js